import React, { useState } from "react";
import "./DocumentVerify.css";

/**
 * A UI that mirrors CIU's online verification page (EN version).
 *   • Verifies students against a configured list.
 *   • On a correct match it opens the corresponding document in a new tab.
 */
const DocumentVerify = () => {
  const [student, setStudent] = useState("");
  const [day, setDay] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [error, setError] = useState("");

  // Predefined list of valid students
  const students = [
    {
      studentNumber: "2206750",
      day: "27",
      month: "07",
      year: "2025",
      document: "transcript.pdf",
    },
    {
      studentNumber: "23575230",
      day: "30",
      month: "01",
      year: "2026",
      document: "transcript_placeholder.pdf",
    },
  ];

  const handleVerify = (e) => {
    e.preventDefault();

    // Check if any student matches the input details
    const matchedStudent = students.find((s) => {
      const matchNumber = s.studentNumber === student.trim();
      const matchDay = s.day === day.trim();
      // Handle "07" vs "7" for month if necessary, though strict match is clearer.
      // We'll allow single digit input to match zero-padded config if we want,
      // but matching the config exactly is safer for now.
      // Let's keep the user's flexible logic: "07" or "7"
      const inputMonth = month.trim();
      const configMonth = s.month;
      const matchMonth =
        inputMonth === configMonth ||
        (inputMonth.length === 1 && "0" + inputMonth === configMonth) ||
        (inputMonth.length === 2 && inputMonth.startsWith("0") && inputMonth.substring(1) === configMonth);

      const matchYear = s.year === year.trim();

      return matchNumber && matchDay && matchMonth && matchYear;
    });

    if (matchedStudent) {
      setError("");
      // Open the specific document for the matched student
      window.open(`/documents/${matchedStudent.document}`, "_blank", "noopener,noreferrer");
    } else {
      setError("Invalid Student Number or Issue Date.");
    }
  };

  return (
    <div
      className="min-vh-100 d-flex justify-content-center align-items-center"
      style={{
        backgroundImage: "url('/images/ciu-background.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div
        className="card p-4 text-center shadow"
        style={{ width: "100%", maxWidth: "420px", borderRadius: "10px" }}
      >
        <img
          src="https://sis.ciu.edu.tr/images/newlogo/sis-logo-en-v3.png"
          alt="CIU logo"
          className="img-fluid mb-3"
          style={{ maxWidth: "250px" }}
        />

        <hr />
        <h5 className="mb-2">Student Document Verification</h5>
        <p className="text-muted" style={{ fontSize: "0.9rem" }}>
          To validate your document, you need to fill in all the fields marked with * below.
        </p>

        <form onSubmit={handleVerify}>
          <div className="text-start mb-1 fw-bold">Student No*</div>
          <input
            type="text"
            className="form-control mb-3"
            placeholder="Please Enter"
            value={student}
            onChange={(e) => setStudent(e.target.value)}
          />

          <div className="text-start mb-1 fw-bold">Issue Date*</div>
          <p className="text-muted text-start" style={{ fontSize: "0.9rem" }}>
            Enter the issue date of the document to verify.
          </p>

          <input
            type="text"
            className="form-control mb-2"
            placeholder="Day"
            value={day}
            onChange={(e) => setDay(e.target.value)}
          />
          <input
            type="text"
            className="form-control mb-2"
            placeholder="Month"
            value={month}
            onChange={(e) => setMonth(e.target.value)}
          />
          <input
            type="text"
            className="form-control mb-3"
            placeholder="Year"
            value={year}
            onChange={(e) => setYear(e.target.value)}
          />

          {error && <div className="text-danger mb-2">{error}</div>}

          <button type="submit" className="btn btn-custom w-100">
            Verify
          </button>
        </form>

        <hr />
        <small className="text-muted d-block mt-3">
          ©&nbsp;
          <a href="https://ciu.edu.tr" className="text-decoration-none">
            Cyprus&nbsp;International&nbsp;University
          </a>
          <br />All&nbsp;Rights&nbsp;Reserved&nbsp;•&nbsp;2025
        </small>
      </div>
    </div>
  );
};

export default DocumentVerify;